import preact, { Fragment, FunctionalComponent, h } from 'preact';

import { i18nTranslate } from 'common/helper/i18n/translate';

export const PropertyReportTooltipModalDocuments: FunctionalComponent = (): preact.JSX.Element => (
  <Fragment>
    <p>{i18nTranslate('ReportProperty_TooltipProofOfOwnerShip')}</p>
    <p>{i18nTranslate('ReportProperty_TooltipUploadDocumentPos')}</p>
  </Fragment>
);
